import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconMegaMenu16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconMegaMenu16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M13 3H3a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1M3 2a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm.5 3.5A.5.5 0 0 1 4 5h2.5a.5.5 0 0 1 0 1H4a.5.5 0 0 1-.5-.5M4 7a.5.5 0 0 0 0 1h1.5a.5.5 0 0 0 0-1zm-.5 2.5A.5.5 0 0 1 4 9h1.5a.5.5 0 0 1 0 1H4a.5.5 0 0 1-.5-.5M9 5a.5.5 0 0 0 0 1h2.5a.5.5 0 0 0 0-1zm-.5 2.5A.5.5 0 0 1 9 7h1.5a.5.5 0 0 1 0 1H9a.5.5 0 0 1-.5-.5M9 9a.5.5 0 0 0 0 1h1.5a.5.5 0 0 0 0-1z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconMegaMenu16);
